import type { ReactNode } from 'react';
import type { Notification } from '../../types';

// Action types
export type NotificationAction =
  | { type: 'SET_NOTIFICATIONS'; payload: Notification[] }
  | { type: 'ADD_NOTIFICATION'; payload: Notification }
  | { type: 'UPDATE_NOTIFICATION'; payload: Notification }
  | { type: 'DELETE_NOTIFICATION'; payload: string }
  | { type: 'SET_UNREAD_COUNT'; payload: number }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'CLEAR_NOTIFICATIONS' };

export interface NotificationState {
  notifications: Notification[];
  unreadCount: number;
  isLoading: boolean;
  error: string | null;
}

export const initialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  error: null,
};

export interface NotificationProviderProps {
  children: ReactNode;
}

export interface UserSession {
  user: any;
  userRole: string;
  assignedBrandIds: string[];
  setAssignedBrandIds?: (ids: string[]) => void;
}

// Shape nilai NotificationContext (dipakai index.tsx + konsumen).
// Fungsi sengaja longgar (strict:false) agar cocok dgn return hook apa pun.
export interface NotificationContextType {
  notifications: Notification[];
  unreadCount: number;
  isLoading: boolean;
  error: string | null;
  markAsRead: (...args: any[]) => any;
  markAllAsRead: (...args: any[]) => any;
  deleteNotification: (...args: any[]) => any;
  addNotification: (...args: any[]) => any;
  pendingNewOrders: any[];
  showNewOrdersBanner: boolean;
  setShowNewOrdersBanner: (...args: any[]) => any;
  clearPendingNewOrders: (...args: any[]) => any;
  addPendingNewOrders: (...args: any[]) => any;
  updatePendingOrder: (...args: any[]) => any;
}
